export class JQueryUIResizableAdapter {
    // Attaches jQuery UI resizable to $el and forwards lifecycle events via callbacks.
    // Handle visibility toggling (height threshold) is handled internally.
    attach($el, { containment, handles, onStart, onResize, onStop }) {
        $el.resizable({
            containment,
            handles,
            start()  { onStart(); },
            resize() {
                const height = parseFloat($el.css('height'));
                $el.find('div.ui-resizable-se').first()
                    .css('visibility', height > 25 ? 'visible' : 'hidden');
                onResize();
            },
            stop()   { onStop(); },
        });
    }
}
